var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6756 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0711 1.92889 20 5.33333 20H14.6756C18.08 20 20 18.0711 20 14.6667V5.33333C20 1.92889 18.08 0 14.6756 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3689 7.3689C4.91557 7.3689 4.54224 7.74223 4.54224 8.20445V15.0756C4.54224 15.5289 4.91557 15.9022 5.3689 15.9022C5.83112 15.9022 6.20446 15.5289 6.20446 15.0756V8.20445C6.20446 7.74223 5.83112 7.3689 5.3689 7.3689Z",
    fill: "#2042B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.036 4.08887C9.58268 4.08887 9.20935 4.4622 9.20935 4.92442V15.0755C9.20935 15.5289 9.58268 15.9022 10.036 15.9022C10.4982 15.9022 10.8716 15.5289 10.8716 15.0755V4.92442C10.8716 4.4622 10.4982 4.08887 10.036 4.08887Z",
    fill: "#2042B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6402 10.9955C14.178 10.9955 13.8047 11.3688 13.8047 11.831V15.0755C13.8047 15.5288 14.178 15.9022 14.6314 15.9022C15.0936 15.9022 15.4669 15.5288 15.4669 15.0755V11.831C15.4669 11.3688 15.0936 10.9955 14.6402 10.9955Z",
    fill: "#2042B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.e2fca3bb4ab5b2f07ce0f0a317c19f1c.svg";
export { ForwardRef as ReactComponent };